export class Canyon {
	groundY: number;

	constructor(groundY: number) {
		this.groundY = groundY;
	}

	draw(): void {
		// Dağlar (canyon)
		fill(120, 100, 100);
		triangle(450, this.groundY, 520, 300, 590, this.groundY);
		fill(100, 80, 80);
		triangle(500, this.groundY, 560, 320, 620, this.groundY);
	}
}
